import { cardsItems } from '@/mocks/home';

export default function CardsSection() {
  return (
    <section id="cards" className="w-full py-12 md:py-16 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center gap-3 mb-8">
          <div className="w-1 h-6 rounded-full bg-accent-500"></div>
          <h2 className="text-xl md:text-2xl font-black text-foreground-900">精选推荐</h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4">
          {cardsItems.map((card) => (
            <a
              key={card.id}
              href="#cards"
              onClick={(e) => e.preventDefault()}
              className="group flex flex-col rounded-xl overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-200 transition-all cursor-pointer"
            >
              <div className="relative w-full h-40 md:h-44 overflow-hidden">
                <img
                  src={card.image}
                  alt={card.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  width="600"
                  height="400"
                />
                <span className="absolute top-2 left-2 px-2 py-0.5 rounded text-[10px] font-bold bg-primary-500 text-white">
                  {card.tag}
                </span>
              </div>
              <div className="p-3 md:p-4 flex flex-col gap-2 flex-1">
                <h3 className="text-sm font-bold text-foreground-800 group-hover:text-primary-600 transition-colors line-clamp-2 leading-snug">
                  {card.title}
                </h3>
                <p className="text-xs text-foreground-500 line-clamp-2 leading-relaxed">{card.excerpt}</p>
                <span className="text-xs text-foreground-400 mt-auto">{card.time}</span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}